<template>
  <div class="workbench-center">

    <!-- 回答、争议焦点、核心案例 -->
    <!-- <AnalysisPanel
      :data="analysisDataRef"
      :keyword="keyword"
    /> -->
    <div ref="reportRef" id="report">
      <MdFileRead ref="mdFileReadRef" :groupId="groupId" :questionTitle="keyword" :caseCount="caseListData.length" :caseListData="caseListData" :thinkHtml="thinkHtml" :thinkStreaming="thinkStreaming" :rawThinkText="rawThinkText" @caseClick="handleCaseClick" @streamFinish="emit('reportFinish')" @detail="handleDetail" />
    </div>
    <!-- 精选案例 -->
    <CaseListPanel
      ref="caseListPanelRef"
      :data="caseListData"
      :keyword="keyword"
      :year="year"
      :courtName="courtName"
      @detail="handleDetail"
      @pageChange="handlePageChange"
      @sortChange="handleSortChange"
      @goView="handlegoView"
      @favoriteChange="(e) => emit('favoriteChange', e)"
    />

  </div>
</template>

<script setup>
import { ref, watch } from "vue"

// import AnalysisPanel from "./AnalysisPanel.vue"
import CaseListPanel from "./CaseListPanel.vue"
// 导入通用组件
import MdFileRead from './MdFileRead.vue'

import {
  // analysisData,
  // caseListData
} from "./mock"

const props = defineProps({
    keyword:{
        type:String,
        default:""
    },
    year: {
    type: Number,
    default: 0
  },
    courtName:{
        type:String,
        default:""
    },
    groupId:{
        type:String,
        default:""
    },
    caseListData:{
       type: Array,
        default: () => [] // 工厂函数返回空数组
    },
    thinkHtml: {
      type: String,
      default: ''
    },
    thinkStreaming: {
      type: Boolean,
      default: false
    },
    rawThinkText: {
      type: String,
      default: ''
    },
    // 分析报告流式接口参数
    analyzeApiUrl: {
      type: String,
      default: ''
    },
    analyzeReqData: {
      type: Object,
      default: null
    }
})
const emit = defineEmits([
  "detail",
  'goView',
  'search',
  'reportFinish',
  'viewDetail',
  'favoriteChange'
])

const mdFileReadRef = ref(null)
const reportRef = ref(null)
const caseListPanelRef = ref(null)

// 案号点击：定位到案例列表
const handleCaseClick = (ah) => {
  if (caseListPanelRef.value) {
    caseListPanelRef.value.scrollToCase(ah)
  }
}

// 左侧菜单点击报告时，滚动到此区域
const scrollToReport = () => {
  if (reportRef.value) {
    reportRef.value.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

// 对外暴露方法
const startAnalyze = () => {
  if (mdFileReadRef.value) {
    mdFileReadRef.value.startAnalyzeStream()
  }
}
defineExpose({
  scrollToReport,
  mdFileReadRef,
  startAnalyze,
  cancelAnalyze() {
    mdFileReadRef.value?.cancelAnalyze?.()
  },
  caseListPanelRef
})

// 当 analyzeApiUrl 有值时，调用 MdFileRead 的流式请求
watch(() => props.analyzeApiUrl, (val) => {
  if (val && props.analyzeReqData && mdFileReadRef.value) {
    mdFileReadRef.value.startStreamFetch(val, props.analyzeReqData)
  }
}, { immediate: true })

const handlegoView = (item) => {
    emit('goView',item)
}
// 分析结果
// const analysisDataRef = ref(analysisData)

// 案例列表
// const caseList = ref(caseListData)
// console.log(caseList,'caseList')
/**
 * 查看详情
 */
const handleDetail = (item) => {

  emit("detail", item)

}

/**
 * 排序
 */
const handleSortChange = (sort) => {

  console.log("排序：", sort)

  // 接口调用
  // getCaseList({
  //    sort
  // })

}

/**
 * 分页
 */
const handlePageChange = (pageInfo) => {

  console.log(pageInfo)

  // getCaseList({
  //     page:pageInfo.page,
  //     size:pageInfo.pageSize
  // })

}
</script>

<style scoped lang="less">

.workbench-center{

    flex:1;

    min-width:0;

    display:flex;

    flex-direction:column;

    // gap:28px;

}

</style>